import { BrandTabs } from "entities/pages/types";
import { useParams } from "react-router-dom";
import PageModules from "./components/PageModules";
import { PageModulesProvider } from "./components/PageModules/context";
import SettingsModulesContainer from "./components/SettingsModules";

const ModulesContainer = () => {
  const { tabId } = useParams();

  if (tabId === BrandTabs.Settings) {
    return (
      <PageModulesProvider>
        <SettingsModulesContainer />
      </PageModulesProvider>
    );
  }

  return (
    <PageModulesProvider>
      <PageModules />
    </PageModulesProvider>
  );
};

export default ModulesContainer;
